import InformationFilled20 from '@carbon/icons-react/es/information--filled/20';
import Information16 from '@carbon/icons-react/es/information/16';
import ViewOff16 from '@carbon/icons-react/es/view--off/16';
import { Alert as AntAlert } from 'antd';
import { AlertProps } from 'antd/lib/alert';
import React from 'react';
import styled, { css } from 'styled-components';
import { switchProp, prop } from 'styled-tools';

const renderIcon = (type) => {
  switch (type) {
    case 'private':
      return <ViewOff16 />;
    case 'warning':
    case 'info':
      return <InformationFilled20 />;
    default:
      return <Information16 />;
  }
};

export const Alert = styled(AntAlert).attrs(({ showIcon, type }) => ({
  icon: showIcon ? renderIcon(type) : null,
  type: type || 'default',
}))<AlertProps>`
  ${switchProp(prop('type', 'default'), {
    warning: css`
      background: var(--warning-bg-color);
      border-color: var(--warning-border-color);

      .ant-alert-icon {
        color: var(--warning-border-color);
      }

      .ant-alert-message {
        width: 80%;
        color: var(--gray-80);
      }
    `,
    private: css`
      background: var(--private-01);
      border-color: var(--private-01);

      .ant-alert-icon {
        color: var(--gray-80);
      }

      .ant-alert-message {
        width: 80%;
        color: var(--gray-80);
      }
    `,
    info: css`
      .ant-alert-icon {
        color: var(--blue-60);
      }
    `,
    default: css`
      background: var(--gray-10);
      border-color: transparent;

      .ant-alert-icon {
        color: var(--gray-50);
      }

      .ant-alert-message {
        width: 80%;
        color: var(--gray-80);
      }
    `,
  })};

  align-items: flex-start;
  display: flex;
  padding: var(--spacing-05);
  border-radius: 0;

  .ant-alert-icon {
    left: unset;
    margin: var(--spacing-01) var(--spacing-05) 0 0;
    position: relative;
    top: unset;
  }
`;
